import { LayoutDto } from 'gleblu-socket-api';

import Layout from '../interfaces/layout/Layout';

export function fromDto(layoutDto: LayoutDto): Layout {
  const { uuid, placeUuid, mergedTableUuids, tableUuids, tableTypeUuids, label, type, isOpen } = layoutDto;
  return {
    uuid,
    placeUuid,
    mergedTableUuids,
    tableUuids,
    tableTypeUuids,
    label,
    size: {
      width: 0,
      height: 0,
    },
    type,
    isOpen,
  };
}

export function toDto(layout: Layout): LayoutDto {
  const { uuid, placeUuid, mergedTableUuids = [], tableUuids = [], tableTypeUuids = [], label, type, isOpen } = layout;
  return {
    uuid,
    placeUuid,
    mergedTableUuids,
    tableUuids,
    tableTypeUuids,
    label,
    type,
    isOpen,
  };
}
